interface EducationProgressProps {
  completed: number
  total: number
}

export function EducationProgress({ completed, total }: EducationProgressProps) {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0
  const isCompleted = completed === total && total > 0

  return (
    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Ваш прогресс
        </h3>
        <span className="text-sm font-medium text-gray-600">
          {completed} из {total} карточек изучено
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-3 mb-4">
        <div 
          className="bg-blue-600 h-3 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Прогресс изучения: ${percentage}%`}
        />
      </div>

      {/* Progress text */}
      <div className="text-center">
        {isCompleted ? (
          <div className="text-green-600 font-medium">
            🎉 Поздравляем! Вы изучили все карточки!
          </div>
        ) : (
          <div className="text-gray-600">
            <span className="font-semibold text-blue-600">{percentage}%</span> изучено
          </div>
        )}
      </div>

      {/* Motivational message */}
      {!isCompleted && completed > 0 && (
        <div className="mt-3 text-center">
          <p className="text-sm text-gray-500">
            Отличная работа! Продолжайте изучение.
          </p>
        </div>
      )}
    </div>
  )
}